import React from 'react';
import { Divider } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import { useTranslation } from 'react-i18next';
import KpiCard from '../../../components/cards/KpiCard';
import CustomDonutChart from '../../../components/charts/CustomDonutChart';

import { useStyles } from './styles';

interface IKpiData {
  value: number;
  meta: number;
}

interface IKpisAndDf {
  mttrData: IKpiData;
  mtbfData: IKpiData;
  dfData: number;
}

const KpisAndDf: React.FC<IKpisAndDf> = ({ mttrData, mtbfData, dfData }) => {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <div className={classes.upContentContainer}>
      <div className={classes.kpisContainer}>
        <KpiCard
          title="MTTR"
          value={mttrData.value}
          refValue={mttrData.meta}
          subtitle={t('screens:availability.goal')}
          unit="h"
        />
        <Divider
          flexItem
          orientation="horizontal"
          variant="middle"
          style={{ height: 1 }}
        />
        <KpiCard
          title="MTBF"
          value={mtbfData.value}
          refValue={mtbfData.meta}
          subtitle={t('screens:availability.goal')}
          unit="h"
        />
      </div>
      <Divider flexItem orientation="vertical" />
      <CustomDonutChart
        title={t('screens:availability.physicalAvailability')}
        values={[dfData]}
        categories={[
          t('screens:availability.available'),
          t('screens:availability.unavailable'),
        ]}
        color={theme.palette.primary.main}
        inactiveColor="#7B7B7B"
        // height="100%"
        unit="%"
        tooltip={false}
      />
    </div>
  );
};

export default KpisAndDf;
